export const scene3Frames = [
  // 10
  {
    url: 'Scene10',
    position: {
      yaw: 120.9 * Math.PI / 180,
      pitch: -1.55 * Math.PI / 180,
    },
    transformations: {
      perspective: {
        extraTransforms: 'perspective(600px) rotateY(-33deg) skewY(-2deg) scale(0.1)'
      }
    },
    style: {
      width: '880px',
      height: '800px',
      backgroundSize: 'contain',
    }
  },
  // 11
  {
    url: 'Scene11',
    position: {
      yaw: 141.3 * Math.PI / 180,
      pitch: -2.4 * Math.PI / 180,
    },
    transformations: {
      perspective: {
        extraTransforms: 'perspective(500px) rotateY(-19deg) skewY(-2deg) scale(0.25)'
      }
    },
    style: {
      width: '704px',
      height: '488px',
      backgroundSize: 'contain',
    }
  },
  // 12
  {
    url: 'Scene12',
    position: {
      yaw: 177.1 * Math.PI / 180,
      pitch: -3.2 * Math.PI / 180,
    },
    transformations: {
      perspective: {
        extraTransforms: 'perspective(200px) rotateY(-1deg) skewY(0deg) scale(0.333333333)'
      }
    },
    style: {
      width: '816px',
      height: '468px',
      backgroundSize: 'contain',
    }
  },
  // 1
  {
    url: 'Scene1',
    position: {
      yaw: -28.95 * Math.PI / 180,
      pitch: -2.75 * Math.PI / 180,
    },
    transformations: {
      perspective: {
        extraTransforms: 'perspective(600px) rotateY(-14deg) skewY(-1.5deg) scale(0.25)'
      }
    },
    style: {
      width: '868px',
      height: '536px',
      backgroundSize: 'contain',
    }
  },
  // 2
  {
    url: 'Scene2',
    position: {
      yaw: -2 * Math.PI / 180,
      pitch: -3.2 * Math.PI / 180,
    },
    transformations: {
      perspective: {
        extraTransforms: 'perspective(200px) rotateY(0deg) skewY(0deg) scale(0.333333333)'
      }
    },
    style: {
      width: '822px',
      height: '462px',
      backgroundSize: 'contain',
    }
  },
  // 3
  {
    url: 'Scene3',
    position: {
      yaw: 24.75 * Math.PI / 180,
      pitch: -2.9 * Math.PI / 180,
    },
    transformations: {
      perspective: {
        extraTransforms: 'perspective(300px) rotateY(9deg) skewY(1.5deg) scale(0.3333333333)'
      }
    },
    style: {
      width: '690px',
      height: '426px',
      backgroundSize: 'contain',
    }
  },
];
